class EmptyService {
  isEmpty(data) {
    if (undefined === data) {
      return true
    }
    if (data === null) {
      return true
    }
    if (data === 0) {
      return true
    }
    if (data === '') {
      return true
    }
    if (data === '0') {
      return true
    }
    return false
  }

  getNullIfEmpty(data) {
    return this.isEmpty(data) ? null : data
  }
}

export default new EmptyService()
